import React, { useState } from 'react';

import { MerchantsShowCredentialsForm } from 'pages/Merchants/MerchantsShow/MerchantsShowCredentials/components/MerchantsShowCredentialsForm';
import { Form, useCreate, useNotify } from 'react-admin';
import { FieldValues } from 'react-hook-form';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { Create } from 'shared/react-admin/Create/Create';

type Props = {
  open: boolean;
  onClose: () => void;
  merchantId: string | undefined;
  merchantName: string | undefined;
};

interface CreateFormValues extends FieldValues {
  merchant: string;
  provider: string;
  name: string;
  comment: string;
  credentials: Record<string, any>;
}

export const MerchantsShowCredentialsCreateDialog: React.FC<Props> = ({
  open,
  onClose,
  merchantId,
  merchantName,
}) => {
  const [create] = useCreate();
  const notify = useNotify();
  const [errors, setErrors] = useState<string[]>([]);

  const onSubmit = (formValues: CreateFormValues) => {
    create(
      'merchant_credentials',
      {
        data: {
          ...formValues,
          merchant: merchantId,
        },
      },
      {
        onSuccess: (merchantCredentials) => {
          notify(
            <>
              Реквизит доступа <TypographyBold text={merchantCredentials.name} /> создан
            </>,
            { type: 'success' },
          );
          onClose();
        },
        onError: (error) => {
          setErrors((error as Error)?.message.split('\n'));
          notify(`Ошибка: ${(error as Error).message}`, { type: 'error' });
        },
      },
    );
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      scroll="body"
      sx={{ '& .MuiPaper-root': { maxWidth: '1280px' } }}
    >
      <Create resource="merchant_credentials" sx={{ margin: 0, '& .RaCreate-main': { margin: 0 } }}>
        <Form onSubmit={onSubmit as any}>
          <CardHeader
            appendActions={[
              <CloseIconButton
                key="close-button"
                onClose={onClose}
                size="medium"
                sx={{ padding: '6px' }}
              />,
            ]}
            sx={{ padding: '24px' }}
            title="Создание реквизитов доступа"
            titleSize="smallBold"
          />
          <CardContent sx={{ padding: '0 24px !important' }}>
            <MerchantsShowCredentialsForm errors={errors} merchantName={merchantName} />
          </CardContent>
          <CardActionsButtons
            rightActionsSlot={[
              <Button key="cancel" label="Отменить" onClick={onClose} variant="outlined" />,
              <Button key="create" label="Создать" type="submit" variant="contained" />,
            ]}
          />
        </Form>
      </Create>
    </Dialog>
  );
};
